import React from "react";
import S from "./Tag.styled";
import { getBgColor, translateColor } from "@/src/helpers";

type TagProps = {
  tag: string;
};

const Tag: React.FC<TagProps> = ({ tag }) => {
  const tagArray = tag.split("|");
  const tagColor = tagArray[tagArray.length - 1];
  const category = tagArray.slice(0, -1).join(" ");

  return (
    <S.Tag $color={getBgColor("dark", translateColor(tagColor))}>
      {category}
    </S.Tag>
  );
};

export default Tag;
